const FooterComponent = (props) => <footer {...props}>Copyright © 2021, ResumeRating.co (BETA)</footer>;
export default FooterComponent;